import { Button, Stack, TextField } from "@mui/material";
import { useAuth } from "../../providers/AuthenticationProvider";
import { useState } from "react";
import { useNetwork } from "../../providers/NetworkProvider";
import { useSnackbar } from "../../providers/SnackbarProvider";

const MakeAffiliateMaster = () => {
	const [newAffilaiteUid, setNewAffiliateUid] = useState<string>("");
	const { makePost } = useNetwork();
	const { openLoadingSnackbar, closeLoadingSnackbar, openSnackbar } =
		useSnackbar();
	const { user } = useAuth();

	const handleNewAffiliateUidChange = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		setNewAffiliateUid(event.target.value);
	};
	const handleMakeAffiliate = async () => {
		if (user == null) return;
		openLoadingSnackbar();
		try {
			const tokenId = await user.getIdToken();
			const res = await makePost(
				"admin/createAffiliateMaster",
				{
					userUid: newAffilaiteUid,
				},
				tokenId
			);
			console.log(res);
			if (res.status === 200) {
				openSnackbar(
					"Success",
					"The user has been made a trader",
					"success"
				);
			} else {
				throw new Error("something went wrong");
			}
		} catch (err) {
			const error = err as Error;

			openSnackbar("Error", error.message, "error");
			console.error(err);
		}
		closeLoadingSnackbar();
	};
	return (
		<>
			<Stack
				spacing={2}
				sx={{ maxWidth: 440, margin: "auto", display: "block" }}
			>
				<h3>Make Afflliate Master (Christian)</h3>
				<TextField
					id="uid"
					label="uid"
					color="primary"
					fullWidth
					value={newAffilaiteUid}
					onChange={handleNewAffiliateUidChange}
				/>
				<Button
					variant="contained"
					color="secondary"
					onClick={handleMakeAffiliate}
					size="large"
					fullWidth
					sx={{
						height: "55px",
						textTransform: "none",
						fontFamily: "Work Sans !important",
					}}
				>
					Make Affiliate Master
				</Button>
			</Stack>
		</>
	);
};

export default MakeAffiliateMaster;
